module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_3016.7a5eb129.png";